import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { GrCloudDownload } from "react-icons/gr";

export default function BulkImport({ content }) {
  return (
    <div>
      <div className="group relative cursor-pointer">
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content={`Bulk ${content}`}
          className="text-sm bg-gray-300 text-blue-700 shadow-sm
           font-semibold rounded-md px-2 py-2 flex gap-2 border-1 border-y-sky-950 items-center
            justify-center text-center hover:text-white hover:bg-gray-700 transition-colors "
        >
          <GrCloudDownload size={18} />
           {content} Unit
        </div>
      </div>
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px]  !text-white z-20 shadow-md"
      />
    </div>
  );
}
